import React from 'react';
import Layout from '../components/Layout';
import PortfolioGrid from '../components/PortfolioGrid';
import PortfolioData from '../data/portfolio/PortfolioData.json';

const filters = [
  { id: 1, text: 'All', value: 'all' },
  { id: 2, text: 'Africa', value: 'africa' },
  { id: 3, text: 'Latin America', value: 'latin america' },
  { id: 4, text: 'Asia', value: 'asia' },
];

const Photography = () => {
  return (
    <Layout>
      <div className="section">
        <div className="container">
          <div className="section-title">
            <h1>Photography</h1>
            <p className="section-subtitle">
              A knack for finding interesting corners
            </p>
          </div>

          <PortfolioGrid items={PortfolioData} filters={filters} />
        </div>
      </div>
    </Layout>
  );
};

export default Photography;
